export const environment = {
  production: true,
  buildId: '2775019509818931',
  configFile: 'config.json',
};
